import Promise from 'bluebird'

/**
 * Retries the given function when a network error is thrown.
 */
export function retryOnNetworkFailure (fn) {
  let retryCount = 0
  let maxRetryCount = 5
  let backoffTime = 300
  let doneRetryingFn
  let onFirstRetry
  let valFromFirstRetry
  let recoveredFn
  const promise = Promise.try(async () => {
    const run = async () => {
      try {
        return {
          result: await fn()
        }
      } catch (error) {
        if (error.message === 'Network Error' || error.message === 'Network Failure') {
          return {
            error
          }
        }

        throw error
      }
    }

    let lastError
    while (retryCount < maxRetryCount) {
      const result = await run()
      if (result.error) {
        lastError = result.error
        retryCount++
        if (retryCount === 1 && onFirstRetry) {
          valFromFirstRetry = await onFirstRetry(lastError)
        }
        await Promise.delay(retryCount * backoffTime)
        continue
      }

      if (retryCount > 0 && recoveredFn) {
        await recoveredFn(valFromFirstRetry)
      }

      return result.result
    }

    if (doneRetryingFn) {
      return doneRetryingFn(lastError, valFromFirstRetry)
    }

    throw lastError
  })

  promise.retry = (times) => {
    maxRetryCount = times
    return promise
  }

  promise.firstRetry = (fn) => {
    onFirstRetry = fn
    return promise
  }

  promise.doneRetrying = (fn) => {
    doneRetryingFn = fn
    return promise
  }

  promise.backoffTime = (time) => {
    backoffTime = time
    return promise
  }

  promise.recovered = (fn) => {
    recoveredFn = fn
    return promise
  }

  return promise
}

export function extractMessageFromError (err) {
  if (err.response) {
    return err.response.data
      ? err.response.data.message
      : err.message
  }

  return err.message
}



// WEBPACK FOOTER //
// ./src/client/utils/errorUtil.js